<template>
    <b-field :label="this.label">
        <qd-taginput v-if="items"
                    :value="selected"
                    :data="filteredItems"
                    autocomplete
                    open-on-focus
                    :append-to-body="appendToBody"
                    :field="field"
                    type="is-primary"
                    :icon="icon"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    @typing="updateSearch"
                    @input="inputHandler">
        </qd-taginput>
    </b-field>
</template>

<script>
import traductionLibelleEtat from '@/services/devisCommandes/traductionLibelleEtat';

export default {
  name: 'libelleTagInput',
  props: {
    value: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      default: 'libellei18n',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'magnify',
    },
  },
  data() {
    return {
      search: null,
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    filteredItems() {
      const itemsToFilter = this.field === 'libelle' ? this.items : traductionLibelleEtat(this.$i18n, this.items);
      return itemsToFilter
        .filter((option) => !this.alreadySelected(option) && this.searchMatch(option));
    },
  },
  methods: {
    updateSearch(search) {
      this.search = search;
    },
    inputHandler(selected) {
      this.selected = selected;
    },
    alreadySelected(item) {
      return this.selected.map(c => c.libelle).includes(item.libelle);
    },
    searchMatch(item) {
      return this.search != null
        ? item[this.field].toString()
          .toLowerCase().indexOf(this.search.toLowerCase())
          >= 0
        : true;
    },
  },
};
</script>
